/*global Base64
 */
window.o_global = window.o_global || {};
window.o_util = window.o_util || {};

o_global.links = o_global.links || (function() {
    "use strict";

    var extraParam = (function() {
        var DATA_EXTRA_PARAM = "data-extra-param";

        /**
         * Init function
         *
         * @private
         */
        function _init() {
            o_util.event.delegate(document, "mousedown", ".js_hasExtraParam", function() {
                var url = this.getAttribute("href"),
                    extraParam = this.getAttribute(DATA_EXTRA_PARAM);

                if (extraParam) {
                    this.setAttribute("href", o_util.fragment.push(extraParam, url));
                }
            });
        }

        return {
            "init": _init
        };
    }()),
    /*
     * Link Masking
     *
     * Diese JavaScript Funktion löst maskierte Links für Touch und nicht Touch UI's auf.
     *
     * Der maskierte Link hat folgende Struktur:
     *
     * <span class="ub64e" data-ub64e="AWDOKAFJSEF">Link 1</span>
     *
     * Touch:
     * Bei Touch UI's wird gibt es kein mouseover, Deswegen wird der <span> bei touchstart in einen Link umgewandelt.
     *
     * Nicht Touch:
     * Hier wird der <span> beim mouseover einfach in einen Link umgewandelt.
     *
     * Das Link umwandeln:
     * Es werden alles CSS-Klassen (bis auf ub64e) übernommen.
     * Es wird das Attribut data-extra-param übernommen.
     * Das Attribut data-ub64e wird decodiert und als href an den Link geschrieben
     * Alles HTML innerhalb des span's wird innerhalb des a-Tags eingefügt.
     */
        masking = (function() {
            var CLASS_UB64E = "ub64e",
                fnWrapper = {};

            fnWrapper.realClick = function(link) {
                link.click();
            };

            fnWrapper.replaceLink = function() {
                var _self = this,
                    children = _self.childNodes,
                    attributes = _self.attributes,
                    classes = _self.getAttribute("class").split(" ").filter(function(value) {
                        return value.replace(/\s+/g, "").length !== 0;
                    }),
                    style = _self.getAttribute("style"),
                    target = _self.getAttribute("data-target"),
                    parent = _self.parentNode,
                    ub64d = Base64.decode(_self.getAttribute("data-" + CLASS_UB64E)),
                    link = document.createElement("a"),
                    i; // Iterator variable.

                // Copy all classes except ub64e
                for (var k = 0, length = classes.length; k < length; k++) {
                    if (classes[k] !== CLASS_UB64E) {
                        link.classList.add(classes[k]);
                    }
                }

                // Copy href
                link.setAttribute("href", ub64d);

                // Copy Inline styles & target if there are any
                style && link.setAttribute("style", style);
                target && link.setAttribute("target", target);

                // Copy data attributes, except from data-ub64e
                for (i = 0; i < attributes.length; i++) {
                    if (attributes[i].name.indexOf("data-") !== -1 && attributes[i].name !== "data-ub64e") {
                        link.setAttribute(attributes[i].name, attributes[i].value);
                    }
                }

                // Copy Inner Elements
                while (children.length > 0) {
                    // The exact same childNodes of the masked link have to be appended in the new link element,
                    // otherwise the registered event handlers from other teams will stop working
                    var child = this.removeChild(children[0]);

                    link.appendChild(child);
                }

                parent.replaceChild(link, _self);

                return link;
            };

            fnWrapper.getReal = function(link) {
                if (link.classList.contains(CLASS_UB64E)) {
                    link = fnWrapper.replaceLink.call(link);
                }

                return link;
            };

            fnWrapper.init = function() {
                o_util.event.delegate(document, "touchstart", "." + CLASS_UB64E, function() {
                    fnWrapper.replaceLink.call(this);
                }, true);

                o_util.event.delegate(document, "mouseover", "." + CLASS_UB64E, function() {
                    fnWrapper.replaceLink.call(this);
                });

                o_util.event.delegate(document, "ub64e", "." + CLASS_UB64E + ", a", function() {
                    var _self = this;

                    if (this.classList.contains(CLASS_UB64E)) {
                        _self = fnWrapper.replaceLink.call(this);
                    }

                    o_global.links.masking.realClick(_self);
                });
            };

            return {
                "init": fnWrapper.init,
                "realClick": fnWrapper.realClick,
                "getReal": fnWrapper.getReal
            };
        }());

    o_global.eventLoader.onReady(1, function() {
        masking.init();
        extraParam.init();
    });

    return {
        "extraParam": extraParam,
        "masking": masking
    };
}());
